import React, { useEffect, useState } from 'react';
import * as Icon from 'react-feather';
import CouponsModal from '../common/modals/coupons-modal';
import DeleteCouponsModal from '../common/modals/delete-coupons-modal';
import DataTableWrapper from '../common/dataTable/dataTableWrapper';
import API_ENDPOINTS from '../../../core/constant/API_ENDPOINTS';
import useFetch from '../../../core/hooks/api/useFetch';
import { useResponsiveColumns } from '../../../core/hooks/useResponsiveColumnsCoupons';
import { Coupon, PackageTypes } from '../../../core/Interface/repositoryInterfaces';

const Coupons = () => {
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(10);
    const [currentPage, setCurrentPage] = useState(0);
    const [selectedCouponId, setSelectedCouponId] = useState<any>(null);
    const [selectedCoupon, setSelectedCoupon] = useState<any>(null);

    const {
        data: couponData,
        refetch: refetchCoupons,
    } = useFetch(API_ENDPOINTS.coupons, { page: currentPage, size: rows });

    const {
        data: packagesDataCollection,
    } = useFetch(API_ENDPOINTS.package, { page: 0, size: 1000 });

    const {
        data: packageTypesDataCollection,
    } = useFetch(API_ENDPOINTS.packageTypes, { page: 0, size: 1000 });

    const coupons: Coupon[] = couponData?.content || [];
    const totalCoupons = couponData?.totalElements || 0;

    const packagesData: PackageTypes[] = (packagesDataCollection?.content || [])
        .filter((packageData: any) => packageData.status === true)
        .map((packageData: any) => ({
            label: `${packageData.title} - ${packageData.type}`,
            value: packageData.id,
        }));

    const packageTypesData: PackageTypes[] = (packageTypesDataCollection || [])
        .filter((packageType: any) => packageType.status === true)
        .map((packageType: any) => ({
            label: packageType.title,
            value: packageType.id,
        }));

    const handleEditClick = (rowData: any) => {
        setSelectedCoupon(null);
        setTimeout(() => setSelectedCoupon(rowData), 0);
    };

    const handleDeleteClick = (rowData: any) => {
        setSelectedCouponId(null);
        setTimeout(() => setSelectedCouponId(rowData.id), 0);
    };

    const columns = [
        { field: "name", header: "Nombre", headerIcon: <Icon.Tag /> },
        { field: "code", header: "Código", headerIcon: <Icon.Hash /> },
        {
            field: "typeDiscount",
            header: "Tipo de Descuento",
            headerIcon: <Icon.Percent />,
            body: (rowData: any) => rowData.typeDiscount ? "Porcentaje %" : "Monto fijo S/."
        },
        { field: "amount", header: "Monto", headerIcon: <Icon.DollarSign /> },
        {
            field: "packetName",
            header: "Paquete",
            headerIcon: <Icon.Package />,
            body: (rowData: any) => rowData.packetName || "Sin paquete"
        },
        {
            field: "packageTypeName",
            header: "Categoría",
            headerIcon: <Icon.Layers />,
            body: (rowData: any) => rowData.packageTypeName || "Sin categoría"
        },
        {
            field: "dateExpired",
            header: "Fecha Válida",
            headerIcon: <Icon.Calendar />,
            body: (rowData: any) => new Date(rowData.dateExpired).toLocaleDateString('es-PE')
        },
        {
            field: "status",
            header: "Estado",
            headerIcon: <Icon.CheckCircle />,
            body: (rowData: any) => (
                <span className={rowData.status ? 'badge-active' : 'badge-inactive'}>
                    {rowData.status ? 'Activo' : 'Inactivo'}
                </span>
            )
        },
    ];

    const getColumns = useResponsiveColumns(columns);

    const onPageChange = (event: any) => {
        const pageNumber = event.first / event.rows;
        setFirst(event.first);
        setRows(event.rows);
        setCurrentPage(pageNumber);
    };

    return (
        <div className="page-wrapper page-settings">
            <div className="content mb-4">
                <div className="content-page-header content-page-headersplit">
                    <h5>Cupones</h5>
                    <div className="list-btn">
                        <button className="btn btn-primary-admin" onClick={() => handleEditClick({})}>
                            <i className="fa fa-plus me-2" /> Agregar Cupón
                        </button>
                    </div>
                </div>
                <DataTableWrapper
                    data={coupons}
                    columns={getColumns()}
                    onEdit={handleEditClick}
                    onDelete={handleDeleteClick}
                    paginator
                    showGridlines
                    rowsPerPage={rows}
                    totalRecords={totalCoupons}
                    first={first}
                    onPageChange={onPageChange}
                    emptyMessage="No se encontraron cupones."
                />
            </div>

            <CouponsModal
                selectedCoupon={selectedCoupon}
                onUpdateSuccess={refetchCoupons}
                packages={packagesData}
                packageTypes={packageTypesData}
            />
            <DeleteCouponsModal
                selectedCouponId={selectedCouponId}
                onDeleteSuccess={refetchCoupons}
            />
        </div>
    );
};

export default Coupons;